import { Component, Input, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';

import { environment } from '../../../../environments/environment';
import { DocumentLinkDisplayModalComponent } from '../../../document-links/components/document-link-display-modal/document-link-display-modal.component';
import { DocumentLinkTypeEnum } from '../../../know-how/enums/document-type.enum';
import { NewsDetailsModel } from '../../models/news-details.model';

@Component({
    selector: 'app-news-details-buttons',
    templateUrl: './news-details-buttons.component.html',
    styleUrl: './news-details-buttons.component.scss'
})
export class NewsDetailsButtonsComponent implements OnInit {
    @Input({ required: true }) newsDetails!: NewsDetailsModel;

    protected documentLinkTypeEnum = DocumentLinkTypeEnum;

    constructor(
        private bsModalService: BsModalService
    ) { }

    ngOnInit(): void {

    }

    protected getTarget(url: string): '_self' | '_blank' {
        const isInternal = url.toLowerCase().startsWith(environment.baseUrl);
        return isInternal ? '_self' : '_blank';
    }

    protected isValidUrl(url: string | null): boolean {
        if (url == null || url == undefined) return false;

        const validStarts = ['http', 'https'];
        return validStarts.some(x => url.toLowerCase().startsWith(x));
    }

    protected openDocumentModal(): void {
        let newsDetails = this.newsDetails;

        if (newsDetails.documentId == null) return;
        if (newsDetails.documentTitle == null) return;
        if (newsDetails.documentLinkType == null) return;
        if (newsDetails.documentIsReadByUser == null) return;

        this.bsModalService.show(DocumentLinkDisplayModalComponent, {
            ignoreBackdropClick: true,
            initialState: {
                name: newsDetails.documentTitle,
                documentId: newsDetails.documentId!,
                linkUrl: newsDetails.documentLinkUrl,
                type: newsDetails.documentLinkType,
                acceptanceDeadlineUtc: newsDetails.documentAcceptanceDeadlineUtc,
                isReadByUser: newsDetails.documentIsReadByUser,
            }
        });
    }
}
